import { isEqual } from 'lodash-es';
import { type StateCreator } from 'zustand';
import { type Favorite, type FavoritesStore, type State, type Store } from './types.ts';

export const createFavoritesStore: (initialState: Partial<State>) => StateCreator<Store, [], [], FavoritesStore> =
  initialState => (set, get) => ({
    addFavorite: (favorite: Favorite) => {
      const { favorites } = get();

      if (favorites.some(entry => isEqual(entry, favorite))) {
        return;
      }

      set(state => ({
        favorites: [favorite, ...state.favorites],
      }));
    },
    favorites: initialState.favorites ?? [],
    getFavorites: () => [...get().favorites],
    hasFavorite: (favorite: Favorite) => {
      return get().favorites.some(entry => isEqual(entry, favorite));
    },
    hasFavorites: () => {
      return get().favorites.length > 0;
    },
    removeFavorite: (favorite: Favorite) => {
      const { favorites } = get();

      if (!favorites.some(entry => isEqual(entry, favorite))) {
        return;
      }

      set(state => {
        const index = state.favorites.findIndex(entry => isEqual(entry, favorite));
        const newFavorites = state.favorites.toSpliced(index, 1);

        return {
          favorites: newFavorites,
        };
      });
    },
  });
